export default class GoogleMapsApi {

    constructor() {
        this.apiKey = 'AIzaSyCdUdqTSd6s78dqT7qt_TEH02efBzBY4ZU';
        if (!window._GoogleMapsApi) {
            this.callbackName = '_GoogleMapsApi.mapLoaded';
            window._GoogleMapsApi = this;
            window._GoogleMapsApi.mapLoaded = this.mapLoaded.bind(this);
        }
    }

    load() {
        if (!this.promise) {
            this.promise = new Promise(resolve => {
                this.resolve = resolve;

                if (typeof window.google === 'undefined') {
                    const script = document.createElement('script');
                    script.src = `//maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=${this.callbackName}`;
                    script.async = true;
                    document.body.append(script);
                } else {
                    this.resolve();
                }
            });
        }
        return this.promise;
    }

    mapLoaded() {
        if (this.resolve) {
            this.resolve();
        }
    }

    renderMap(element, mapoptions, center, markers)
    {
        var defaults = {
            zoom                : 6,
            center              : new google.maps.LatLng(center.lat,center.lng),
            mapTypeControl      : true,
            streetViewControl   : true,
            scrollwheel         : false,
            mapTypeId           : google.maps.MapTypeId.ROADMAP
            /*styles              : [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]*/
        };
            
        let mapops    = Object.assign({}, defaults, mapoptions),
            map = new google.maps.Map(element, mapops);

        markers.forEach(function (marker, index) {
            var m = new google.maps.Marker({
                position    : new google.maps.LatLng(marker.lat,marker.lng),
                map         : map,
                icon        : "./assets/images/marker.png"
            });
        });
    }
}